export default {
  translation: {
    shopButton: 'ADD TO GROCERY CART',
    buttonsHeader: 'Buy Ingredients Online',
    unavailableTitle: 'Unfortunately we do not deliver the ingredients to your address. Find offline shops near you where you can buy our products.',
    unavailableButtonLabel: 'FIND NOW',
    viewAll: 'View All',
    substitutionButtonLabel: 'Personalize with AI'
  }
}
